import { WindowLocation } from '@reach/router';
import { getSlug } from './getSlug';

export const activeLocale = (location: WindowLocation, locales?: string[]) => {
  const match =
    locales &&
    locales.find(locale =>
      getSlug(location.pathname).includes(getSlug(locale))
    );

  return match || 'en-US';
};
